@if (recentlyViewedProducts(); as ids) {
  <products-preview
    [ids]="ids"
    [type]="'recentlyViewedProducts'"
    [parentNameForAnalytics]="sourceForAnalytics"
    (showCart)="showCart($event)"
  />
}
